import { Button } from '@mui/material';
import { useState, useCallback, useContext } from 'react';

import { CurrencyTypeEnum } from '../../../model/currency_type.enum';
import { GlobalContext } from '../../../providers/global-provider';
import { MarketDataContext } from '../../../providers/market-data/market-data-provider';
import { clearTabPersistentState } from '../../../providers/use-persistent-state';

import ConfirmResetModal from './confirm-reset-modal';

export default function ResetDataButton() {
  const { marketDataOverviewCurrentToken: currentCurrency } = useContext(GlobalContext);
  const { removeAllVolSeries } = useContext(MarketDataContext);

  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
  }, [setOpenModal]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleConfirmReset = () => {
    handleCloseModal();
    clearTabPersistentState(currentCurrency as CurrencyTypeEnum);
    removeAllVolSeries?.();
  };

  return (
    <>
      <Button onClick={handleOpenModal} className="btn-reset">
        <span>Reset data</span>
      </Button>
      <ConfirmResetModal
        open={openModal}
        handleClose={handleCloseModal}
        handleResetData={handleConfirmReset}
      />
    </>
  );
}
